export default __webpack_public_path__ + "media/images/icons/shield-alt-solid-23bbd78b2972d0ba9b4123734810bb74.svg";